import React, { useEffect, useState } from 'react';
import CreateReferral from './CreateReferral';
import ListReferral from './ListReferral';
import { ENUM_CUS_EVENT } from '../../../../enums/enums';
import CusPageContainer from '../../../../components/shared/CusPageContainer';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import useToast from '../../../../hooks/useToast';
import useGroupByGroupId from '../../../../hooks/site/useGroupByGroupId';
import { useAppSelector } from '../../../../store';
import { API_GROUP } from '../../../../api/user';
import { useDispatch } from 'react-redux';
import { setRefLinks } from '../../../../store/apps/groupInfoSlice';
import { dispatchCusEvent } from '../../../../utils';
import ErrorBoundary from '../../../../components/material-ui/error_boundary/ErrorBoundary';

export default function ReferralLink() {
  const { group, groupId } = useGroupByGroupId();
  const refLinks = useAppSelector((state) => state.groupInfo.refLinks?.[groupId]) || [];
  const refLinksInfo = useAppSelector((state) => state.groupInfo.refLinksInfo?.[groupId]) || {};
  const [referrals, setReferral] = useState(refLinks);
  const { errorToast } = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatchCusEvent(ENUM_CUS_EVENT.getRefcodeList, { groupId });
  }, []);

  useEffect(() => {
    if (!refLinks || !refLinks.length) return;
    setReferral(refLinks.map((el) => ({ ...el, anchor: '' })));
  }, [refLinks]);

  const createReferralHandler = (comment, pbParams) => {
    API_GROUP.refCode
      .create({ groupId, comment, pbParams })
      .then((e) => {
        console.log(e);
        const data = e.data.data;
        const newStore = [data, ...refLinks];
        dispatch(setRefLinks({ groupId, data: newStore }));
      })
      .catch(console.log);
  };

  const deleteReferralHandler = (id) => {
    API_GROUP.refCode
      .delete({ refcodeId: id })
      .then(() => {
        setReferral((prev) => prev.filter((el) => el.id !== id));
      })
      .catch(console.log);
  };

  const getNewLink = (link, anchor, type) => {
    if (type == 'tg') {
      errorToast('Anchors can only be added to site links.');
      return link;
    }

    return link.includes(anchor) ? '' : anchor;
  };

  const editAnchorHandler = (idReferral, anchor) => {
    if (!idReferral) return;

    setReferral((prev) => {
      const newReferral = [];
      for (let referral of prev) {
        if (referral.id === idReferral) {
          const link = referral.anchor || '';
          const newAnchor = getNewLink(link, anchor);
          newReferral.push({
            ...referral,
            anchor: newAnchor
          });
          continue;
        }
        newReferral.push(referral);
      }

      return newReferral;
    });
  };

  const onCommentChange = (refcodeId, comment, pbParams) => {
    return API_GROUP.refCode
      .update({ refcodeId, comment, pbParams })
      .then(() => {
        setReferral((prev) => {
          const newReferral = [];
          for (let referral of prev) {
            if (referral.id === refcodeId) {
              newReferral.push({ ...referral, comment, pbParams });
              continue;
            }
            newReferral.push(referral);
          }

          return newReferral;
        });
      })
      .catch(console.log);
  };

  return (
    <CusPageContainer title="Referral links" group={group} loader={!group}>
      <ErrorBoundary>
        <CreateReferral createReferralHandler={createReferralHandler} groupId={groupId} />
      </ErrorBoundary>
      <ShowContainer condition={referrals.length}>
        <ListReferral
          refLinksInfo={refLinksInfo}
          referrals={referrals}
          deleteReferralHandler={deleteReferralHandler}
          editAnchorHandler={editAnchorHandler}
          getNewLink={getNewLink}
          onCommentChange={onCommentChange}
        />
      </ShowContainer>
    </CusPageContainer>
  );
}
